import * as $ from 'jquery';
import 'datatables';

export default (function () {
  $('#dataTable').DataTable({
		language: {
		  'url': 'https://cdn.datatables.net/plug-ins/1.10.25/i18n/Arabic.json'
			// More languages : http://www.datatables.net/plug-ins/i18n/
		},
		aaSorting: []
	});
}());
